import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Border from '../Border';
import Headline2 from '../../../Typography/Heading/Headline2';
import Headline3 from '../../../Typography/Heading/Headline3';
import Body1 from '../../../Typography/Body/Body1';
import breakpoints from '../../../Theme/breakpoints';

const CallToActionContainer = styled.div`
  display: flex;
  flex-direction: column;

  a, > button {
    margin-bottom: 12px;
  }

  @media (min-width: ${breakpoints.sm}px) {
    flex-direction: row;

    a, > button {
      margin-right: 12px;
    }
  }
`;

const FlexContainer = styled.dl`
  display: flex;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.sizes.h5};
  color: ${({ theme }) => theme.colors.blackHigh};
`;

const StyledDescriptionTerm = styled.dt`
  padding-right: 8px;
`;

const StyledDescriptionName = styled.dd`
  margin: 0;
`;

const StyledP = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const aboutPropertyTypes = {
  title: PropTypes.string,
  description: PropTypes.node,
  contactTitle: PropTypes.string,
  email: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  telephone: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  callToAction: PropTypes.node,
};

type AboutProperties = InferProps<typeof aboutPropertyTypes>;

const About = ({
  title,
  description,
  contactTitle,
  email,
  telephone,
  callToAction,
}: AboutProperties) => (
  <section>
    <Border />
    <Headline2>
      {title}
    </Headline2>
    <Body1 tag="div">
      {description}
    </Body1>
    {contactTitle && (
      <Headline3>
        {contactTitle}
      </Headline3>
    )}
    {email && (
      <FlexContainer>
        <StyledDescriptionTerm>E:</StyledDescriptionTerm>
        <StyledDescriptionName>
          {email}
        </StyledDescriptionName>
      </FlexContainer>
    )}
    {telephone && (
      <FlexContainer>
        <StyledDescriptionTerm>T:</StyledDescriptionTerm>
        <StyledDescriptionName>
          {telephone}
        </StyledDescriptionName>
      </FlexContainer>
    )}
    {callToAction && (
      <CallToActionContainer>
        {callToAction}
      </CallToActionContainer>
    )}
  </section>
);

About.propTypes = aboutPropertyTypes;

export {
  About as default,
  StyledP,
};
